import { GzTagsEnumFilterWebComponent } from './component/GzTagsEnumFilterWebComponent';
import { WEB_COMPONENT_GZ_TAGS_ENUM_FILTER } from '../../../webcomponents.constants';

export { GzTagsEnumFilterWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TAGS_ENUM_FILTER, GzTagsEnumFilterWebComponent);
